import './clipboard-text-field.scss';
import {useContext} from 'react';
import {ReadOnlyTextField} from '../read-only-text-field/read-only-text-field';
import {Box, Button, Tooltip} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {translations} from '../../i18n/translations';
import {SnackBarContextType} from '../../contexts/snack-bar/types';
import {SnackBarContext} from '../../contexts/snack-bar/context';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

/**
 * Read only text field with a copy button to copy its value to the clipboard.
 */
export const ClipboardTextField = (props: {label: string; value: string; className?: string}) => {
  // Get context
  const snackBarContext: SnackBarContextType = useContext(SnackBarContext);

  // Translations
  const {t} = useTranslation();

  // Copy value to the clipboard
  const handleCopyToClipboard = () => {
    // Copy the text to the clipboard
    navigator.clipboard.writeText(props.value);

    // Success
    snackBarContext.setOfficeToastNotification({
      severity: 'success',
      message: t(translations.clipboard_text_field.success.copy_to_clipboard_success_message),
    });
  };

  return (
    <Box className={`clipboard-text-field-container ${props.className}`}>
      <ReadOnlyTextField className="clipboard-text-field" label={props.label} value={props.value} />
      <Tooltip title={t(translations.clipboard_text_field.copy_to_clipboard_tooltip_message)}>
        <Box className="clipboard-text-field-button">
          <Button
            color="primary"
            variant="outlined"
            endIcon={<ContentCopyIcon />}
            onClick={handleCopyToClipboard}
          >
            {t(translations.clipboard_text_field.copy_to_clipboard_button)}
          </Button>
        </Box>
      </Tooltip>
    </Box>
  );
};
